module.exports = __webpack_public_path__ + "media/newstyle/images/logo-club-de-autores-9e157c3194840125498a515f6b0ec9c0.png";